import {
  CloudPodLiveResponseSchema, CloudPodResponseSchema, CloudPodsResponseSchema, CloudSpendResponseSchema, RunPodCatalogResponseSchema, type CreateRunPodPodRequest,
  GcpZonesResponseSchema, type CreateGcpMachineRequest, type StorageForm,
} from '@couch/shared';
import { empty, json } from './client';

const seg = encodeURIComponent;

/** Pods and VMs Couch creates (docs 56–58, 70–71). */
export const cloudApi = {
  runpodCatalog: () => json(RunPodCatalogResponseSchema, 'GET', '/cloud/runpod/catalog'),
  createRunPodPod: (body: CreateRunPodPodRequest) => json(CloudPodResponseSchema, 'POST', '/cloud/runpod/pods', body),
  gcpZones: () => json(GcpZonesResponseSchema, 'GET', '/cloud/gcp/zones'),
  createGcpMachine: (body: CreateGcpMachineRequest) => json(CloudPodResponseSchema, 'POST', '/cloud/gcp/machines', body),
  cloudPods: () => json(CloudPodsResponseSchema, 'GET', '/cloud/pods'),
  livePod: (id: string) => json(CloudPodLiveResponseSchema, 'GET', `/cloud/pods/${seg(id)}/live`),
  switchPod: (id: string, action: 'start' | 'stop') => json(CloudPodLiveResponseSchema, 'POST', `/cloud/pods/${seg(id)}/${action}`),
  deletePod: (id: string) => empty('DELETE', `/cloud/pods/${seg(id)}`),
  spend: () => json(CloudSpendResponseSchema, 'GET', '/cloud/spend'),
  setGcpKey: (key: string) => empty('PUT', '/cloud/keys/gcp', { key, acknowledged: true }),
  removeGcpKey: () => empty('DELETE', '/cloud/keys/gcp'),
  setStorageKey: (form: StorageForm) => empty('PUT', '/cloud/keys/s3', { ...form, acknowledged: true }),
  removeStorageKey: () => empty('DELETE', '/cloud/keys/s3'),
  checkSpend: () => json(CloudSpendResponseSchema, 'POST', '/cloud/spend/check', {}),
  setLimit: (limitUsd: number | null) => empty('PUT', '/cloud/limit', { limitUsd }),
};

export const CLOUD_PODS_KEY = ['cloud-pods'] as const;
export const CLOUD_SPEND_KEY = ['cloud-spend'] as const;
